module.exports = __webpack_public_path__ + "img/41.a9a4dfb0.jpg";